import { Outlet } from "react-router-dom";
import Employ from "../../../statics/illustrations/employ.svg";
import Question from "../../../statics/illustrations/question.svg";
import Guide from "../../../statics/illustrations/guide.svg";
import { useAppSelector } from "../../../store/hooks";
import useDowload from "../../../customHooks/useDowload";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const Campaign = () => {
  const { isShown, toggle } = useModal();
  const { employee_code, company, name, extra } = useAppSelector(
    (state) => state.user
  );
  const { onDownload, isLoadingDw, error } = useDowload({
    url: `${BASE_URL}/api/images/pdf/CNF-NA-PURLSGUIDE-VERSION6-FEB-22-841670.pdf`,
    filename: `Quick-Guide.pdf`,
  });

  return (
    <>
      <div className="container">
        <div className="gs:grid">
          <div className="col-12 lg:col-8">
            <Outlet />
          </div>
          <div className="col-12 lg:col-4">
            <div className="c-info-campaign">
              <div className="c-info-campaign__employ">
                <div className="c-info-campaign__employ-data">
                  <span className="c-info-campaign__employ-name">{name}</span>
                  <span className="c-info-campaign__employ-info">
                    Employee Code: {employee_code}
                  </span>
                  <span className="c-info-campaign__employ-info">
                    Default Brand: {company}
                  </span>
                </div>
                <img src={Employ} alt="c-info-campaign__employ-illustration" />
              </div>

              <div className="c-info-campaign__indications">
                <div className="c-info-campaign__indications-data">
                  <span className="c-info-campaign__indications-title">
                    Need Help?
                  </span>
                  <span className="c-info-campaign__indications-text">
                    If you have any questions or need support, please contact us
                    using{" "}
                    <span
                      className="c-info-campaign__indications-link"
                      onClick={toggle}
                    >
                      THIS FORM
                    </span>
                  </span>
                </div>
                <img
                  src={Question}
                  alt="question"
                  className="c-info-campaign__indications-illustration"
                />
              </div>
              <div className="c-info-campaign__indications">
                <div className="c-info-campaign__indications-data">
                  <span className="c-info-campaign__indications-title">
                    PURLs User Guide
                  </span>
                  <span className="c-info-campaign__indications-text">
                    This guide will walk you through how to set up your PURLs
                    campaigns, rules of engagement and local store marketing
                    tips.{" "}
                    {!isLoadingDw ? (
                      <span
                        className="c-info-campaign__indications-link"
                        onClick={onDownload}
                      >
                        CLICK HERE.
                      </span>
                    ) : (
                      <span className="c-info-campaign__indications-wait">
                        DOWNLOAD...
                      </span>
                    )}
                  </span>
                </div>
                <img
                  src={Guide}
                  alt="question"
                  className="c-info-campaign__indications-illustration"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isActive={isShown} clouse={toggle}>
        <iframe
          scrolling="no"
          width="1024"
          height="768"
          src="https://www.wrike.com/form/eyJhY2NvdW50SWQiOjE1MzAxMDIsInRhc2tGb3JtSWQiOjYzNjM4M30JNDc5Njk5MzM0MzI4MQkxODU0ZTgyZDhhNDNiOGRmOTAyNzYzZWJlNTQwNjhkNWZiODVjZWI0ODc4ZDg0MDM4M2NiMTMwZDc2OThjNDg0"
        ></iframe>
      </Modal>
    </>
  );
};

export default Campaign;
